import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=a21448f0"
import script from "./TaskDetail.vue?vue&type=script&lang=js"
export * from "./TaskDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskDetail.vue?vue&type=style&index=0&id=a21448f0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a21448f0')) {
      api.createRecord('a21448f0', component.options)
    } else {
      api.reload('a21448f0', component.options)
    }
    module.hot.accept("./TaskDetail.vue?vue&type=template&id=a21448f0", function () {
      api.rerender('a21448f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/pages/TaskDetail.vue"
export default component.exports